import { SiGithub } from '@icons-pack/react-simple-icons';
import Changelog from './index/-Changelog';
import Partner from './index/-Partner';
import Editors from './index/-Editors';
import { Button } from '~/primitives/button';
import { createFileRoute, Link } from '@tanstack/react-router';
import { namesQuery } from '~/util/queries/public/users';
import { seo } from '~/util';

export const Route = createFileRoute('/')({
    loader: async ({ context: { queryClient } }) =>
        await queryClient.fetchQuery(namesQuery()),
    head: () => ({
        meta: seo({
            description:
                'The All Rated Extreme Demons List (AREDL) is a community based on ranking every rated Extreme Demon in Geometry Dash as accurately as we can.',
            image: 'https://aredl.net/assets/logo.webp',
            imageAlt: '',
        }),
    }),
    component: Home,
});

function Home() {
    const partners = [
        ['UDL', 'Unrated Demon List'],
        ['IDL', 'Insane Demon List'],
        ['EDEL', 'Extreme Demon Enjoyments List'],
        ['SFH', 'Song File Hub'],
        ['PEMONLIST', 'Pemonlist (Platformer List)'],
        ['GDDL', 'Geometry Dash Demon Ladder'],
        ['NLW', 'Non List Worthy'],
        ['2PL', '2 Player List'],
        ['TSL', 'The Shitty List'],
        ['GSV', 'Global Stats Viewer'],
    ];

    return (
        <div className="p-4 grid gap-8 grid-cols-1 lg:grid-cols-[2.8fr_1.3fr]">
            <div>
                <div className="flex flex-col lg:flex-row p-4 rounded-xl gap-4 lg:gap-20 justify-center items-center bg-background-darker">
                    <section className="w-full lg:w-3/4 my-4">
                        <h1 className="text-4xl text-center font-bold text-secondary-foreground">
                            WELCOME TO THE <span>AREDL</span>!
                        </h1>
                        <p className="mt-1 text-lg text-secondary-light text-center">
                            The All Rated Extreme Demons List (AREDL) is a
                            community based on ranking every rated Extreme Demon
                            in Geometry Dash as accurately as we can.
                        </p>
                        <p className="mt-1 text-center">
                            <strong>Disclaimer:</strong> The AREDL placements
                            are decided based on various difficulty opinions
                            from many players. Your opinions WILL differ from
                            this list,{' '}
                            <strong>
                                do NOT take it as an objective fact.
                            </strong>
                        </p>
                    </section>
                    <Button asChild>
                        <Link to="/list">VIEW LIST</Link>
                    </Button>
                </div>

                <section className="my-4 p-8 rounded-xl bg-background-darker">
                    <Changelog />
                </section>

                <section className="my-4 p-8  rounded-xl bg-background-darker">
                    <h2 className="text-2xl font-bold  mb-4">
                        OTHER WEBSITES/PARTNERS
                    </h2>
                    <p className="text-secondary-light mb-4">
                        You can find below different lists/websites/resources
                        integrated on our website and/or partnered with us!
                        Click on their icon for more information about them!
                    </p>
                    <div className="flex flex-wrap gap-2 justify-start">
                        {partners.map(([infoType, name]) => (
                            <Partner
                                icon={`/assets/partners/${infoType}.webp`}
                                name={name}
                                infoType={infoType}
                                key={infoType}
                            />
                        ))}
                    </div>
                </section>

                <div className="flex flex-col lg:flex-row py-8 px-4 rounded-xl gap-4 justify-center items-center bg-background-darker">
                    <section className="w-full lg:w-3/4 text-center lg:text-left">
                        <h2 className="text-2xl font-bold text-secondary-foreground">
                            THE AREDL GITHUB
                        </h2>
                        <p className="mt-4 text-secondary-light">
                            All of the AREDL codebase can be found on our GitHub
                            organization. <br />
                            Head over there if you&apos;re curious about how the
                            website works, want to report a bug, or even
                            contribute to the project!
                        </p>
                    </section>
                    <Button
                        className="flex items-center gap-2 ml-1"
                        onClick={() =>
                            window.open(
                                'https://github.com/All-Rated-Extreme-Demon-List',
                                '_blank',
                            )
                        }
                    >
                        <SiGithub /> The Repository
                    </Button>
                </div>
            </div>
            <Editors />
        </div>
    );
}
